module.exports = __webpack_public_path__ + "fonts/德彪钢笔行书字库.fa8dc804.ttf";